import { Component } from "react";

// Catches render/runtime errors in a subtree so one broken page shows a
// message instead of unmounting the whole app (the "black screen").
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI error boundary caught:", error, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="max-w-lg w-full bg-zinc-950 border border-red-500/30 rounded-md p-6">
            <div className="text-[10px] uppercase tracking-[0.18em] text-red-400 font-mono mb-1">Module error</div>
            <h2 className="font-display text-xl font-semibold text-zinc-100">This page hit an error</h2>
            <p className="text-sm text-zinc-400 mt-2">
              The rest of the console is unaffected — use the sidebar to continue, or reload.
            </p>
            <pre className="text-[11px] font-mono text-red-300/80 bg-zinc-900/50 border border-zinc-900 rounded p-3 mt-3 whitespace-pre-wrap break-all">
              {String(this.state.error?.message || this.state.error)}
            </pre>
            <div className="flex gap-2 mt-4">
              <button onClick={() => this.setState({ error: null })} className="bg-zinc-900 border border-zinc-800 hover:border-zinc-700 text-zinc-200 text-sm rounded px-3 py-1.5">Retry</button>
              <button onClick={() => window.location.reload()} className="bg-blue-600 hover:bg-blue-700 text-white text-sm rounded px-3 py-1.5">Reload console</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
